import {AbstractEvent} from "@/modules/base/events";
import {Season} from "@/modules/season/entity";

export class BeforeDayEvaluationEvent extends AbstractEvent {
  constructor(
    public season: Season
  ) {
    super();
  }
}